import React from "react";

/**
 * icon หมุนท้ายชื่อการ์ด/หัวข้อ บอกว่าส่วนไหนกำลังโหลดหรือบันทึกอยู่
 *
 * ค่า `running` ต้องมาจากการ์ดที่ตรวจ `buttonLoadCheck` ของ sequence จริง
 * (BLC_STATUS.LOADING ของ action ของการ์ดนั้น) — ห้ามใส่ state ลอย ๆ เอง
 * เพราะถ้ามี text node หรือ icon ตอนที่ไม่กำลังโหลด จะทำให้ visual gate
 * (tools/compare.js เทียบกับ design bundle) เปลี่ยนไป
 */
export const SectionSpinner: React.FC<{ running: boolean; label: string }> = ({ running, label }) => {
  if (!running) return null;
  return <span className="hv4-spin" role="status" aria-live="polite" aria-label={label} title={label} />;
};

/** มี action ใดในรายการที่กำลัง LOADING หรือไม่ (busy = helper ของการ์ดที่ผูก card name ไว้แล้ว) */
export const anyBusy = (busy: (action: string) => boolean, actions: readonly string[]): boolean =>
  actions.some((action) => busy(action));
